import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// (
//     document.getElementById('theme-css') as HTMLLinkElement
// ).href = `/assets/theme/efaact-blue/theme-light.css?${environment.version}`;
// (
//     document.getElementById('layout-css') as HTMLLinkElement
// ).href = `/assets/theme/efaact-blue/theme-light.css?${environment.version}`;

// let link = document.createElement('link');
// link.id = 'theme-css';
// link.rel = 'stylesheet';
// link.href = `assets/theme/theme-blue.css?${environment.version}`;
// document.body.appendChild(link);

// link = document.createElement('link');
// link.id = 'layout-css';
// link.rel = 'stylesheet';
// link.href = `assets/layout/css/layout-joomla.css${environment.version}`;
// document.body.appendChild(link);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, [
        // {defaultEncapsulation: ViewEncapsulation.Emulated}
        // {defaultEncapsulation: ViewEncapsulation.ShadowDom}
    ])
    .catch(err => console.error(err));
